export default __webpack_public_path__ + "static/media/UKCB-LogoMain.63684f5e.png";